<template>
  <div class="loader">
    <div :style="`background-color: ${color}`"></div>
    <div :style="`background-color: ${color}`"></div>
    <div :style="`background-color: ${color}`"></div>
  </div>
</template>
<script setup>
defineProps({
  color: {
    type: String,
    default: '#37454d',
  },
})
</script>
<style scoped>
@keyframes grow {
  to {
    transform: translateX(-50%) scale(0);
  }
}
.loader {
  display: inline-block;
  height: 5px;
  position: relative;
  width: 20px;
}
.loader div {
  animation: grow 0.5s ease-in-out infinite alternate;
  border-radius: 50%;
  height: 5px;
  position: absolute;
  width: 5px;
  will-change: transform;
}
.loader div:first-child {
  left: 0;
  transform-origin: 100% 50%;
}
.loader div:nth-child(2) {
  animation-delay: calc(0.5s / 3);
  left: 50%;
  transform: translateX(-50%) scale(1);
}
.loader div:last-child {
  animation-delay: calc(0.5s / 3 * 2);
  right: 0;
}
</style>
